export const TEXT_UPLOADING_FILE = "Übertrage Bilder";
export const TEXT_UPLOADING = "Übertrage";
export const TEXT_UPLOADING_FAILED = "Übertragung hatte Fehler.";
export const TEXT_UPLOADING_FINISH = "Stelle fertig";
export const TEXT_UPLOADING_SUCCESS = "Erfolg";
export const TEXT_REPORT_SUBMITTED =
  "Deine Anfrage wurde erfolgreich übermittelt.";
export const TEXT_VERIFY_LOADING = "Verifizieren";
export const TEXT_TITLE_REQUIRED = "Bitte gib einen Titel an.";
export const TEXT_TITLE_VALID = "Bitte nutze keine Sonderzeichen im Titel.";
export const TEXT_TITLE_LENGTH = "Bitte gib einen längeren Titel an.";
export const TEXT_PRICE_REQUIRED = "Bitte gib einen Preis an.";
export const TEXT_PRICE_VALID = "Gib den Preis als Zahl an.";
export const TEXT_EMAIL_REQUIRED = "Bitte gib deine E-Mail an.";
export const TEXT_EMAIL_VALID = "Bitte gib eine valide E-Mail an.";
export const TEXT_EMAIL_LENGTH = "Bitte gib eine längere E-Mail an.";
export const TEXT_PASSWORD_REQUIRED = "Bitte gib dein Password ein.";
export const TEXT_NEW_PASSWORD_REQUIRED = "Bitte gib dein neues Password ein.";
export const TEXT_PASSWORD_SHORT = "Das Passwort hat mindestens 8 Zeichen.";
export const TEXT_PASSWORD_LONG = "Das Passwort hat maximal 64 Zeichen.";
export const TEXT_OTP_RESET_LENGTH = "Der Code hat 16 Zeichen.";
export const TEXT_OTP_VERIFY_LENGTH = "Der Code hat 6 Zeichen.";
export const TEXT_OTP_RESET_REQUIRED = "Gib den Code aus der Mail an.";
export const TEXT_ACK_REQUIRED =
  "Bitte stimme den Bedingungen zur Kontoerstellung zu.";
